import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Preloader } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Старый компонент
 * Использовать новый из ui-kit
 * @todo задача ES-4748
 * @deprecated
 */
export function PagePreloader({ className }) {
  return (
    <div className={cx('component', className)}>
      <Preloader />
    </div>
  );
}

PagePreloader.propTypes = {
  className: PropTypes.string,
};
